<div class="bv-security-keys">
  @if (showChangeKdf) {
    <section class="bv-security-keys__section">
      <app-change-kdf></app-change-kdf>
    </section>
  }

  <section class="bv-security-keys__section bv-security-keys__api-section">
    <h2 class="bv-security-section-title">{{ "apiKey" | i18n }}</h2>
    <p class="bv-security-page__desc bv-security-keys__api-desc">{{ "userApiKeyDesc" | i18n }}</p>
    <div class="bv-security-keys__api-actions">
      <button
        type="button"
        bitButton
        buttonType="secondary"
        class="bv-security-outline-btn"
        (click)="viewUserApiKey()"
      >
        {{ "viewApiKey" | i18n }}
      </button>
      <button
        type="button"
        bitButton
        buttonType="secondary"
        class="bv-security-outline-btn"
        (click)="rotateUserApiKey()"
      >
        {{ "rotateApiKey" | i18n }}
      </button>
    </div>
  </section>
</div>
